<template>
  <div class="pg-dialog-select-table" :id="idPrefix">
    <div class="seach-content" v-popover:popoverRef>
      <Input
        ref="inputRef"
        class="seach-content-input"
        :class="{ 'seach-content-input-val': !!inputVal }"
        :size="size"
        :value="inputVal"
        :disabled="disabled"
        :placeholder="placeholder"
        @focus="inputFocus"
        @blur="inputBlur"
        :validate-event="validateEvent"
        @input="setInputVal"
        @keydown.native="onKeydown"
        @keyup.enter.native="onEnter"
        @click.native.stop="inputClick"
      >
        <template #suffix>
          <i
            class="el-icon-circle-close seach-content-input-clear"
            v-if="!disabled"
            @click.stop="inputClear"
          ></i>
          <i
            class="ivu-icon-icon-pg-serach seach-content-input-serach"
            v-if="!disabled"
            @click.stop="showModal"
          ></i>
        </template>
      </Input>
      <slot name="btn"></slot>
    </div>
    <Popover
      ref="popoverRef"
      :popper-class="
        zPopoverIndex ? 'pg-dialog-select-table__zIndex' : 'pg-dialog-select-table__popper'
      "
      placement="bottom-start"
      trigger="click"
      v-model="visible"
      @after-leave="afterLeave"
    >
      <div v-if="readenPopover">
        <div v-if="!!setLocalStorageSelectPrice" style="padding: 10px 20px">
          <Checkbox v-model="isSelectPrice">选择供应商时自动带入价格</Checkbox>
        </div>
        <PgTable
          class="pg-dialog-select-table__table"
          ref="pgTableRef"
          :seachPlaceholder="placeholder"
          :maxHeight="400"
          :columnTableCode="columnTableCode"
          :column="column"
          :seqShow="seqShow"
          :loading="loading"
          :isSelection="multiple"
          :scroll="onScroll"
          @row-change="rowChange"
        >
        </PgTable>
      </div>
    </Popover>
    <PgSelentMain
      v-if="showRander"
      v-bind="$attrs"
      :width="width"
      :columnTableCode="columnTableCode"
      :column="column"
      :multiple="multiple"
      :valueIsObj="valueIsObj"
      :valueIsArray="valueIsArray"
      :selection="value"
      :selectionKey="selectionKey"
      :requestDataKey="requestKey"
      :showKey="showName"
      :seqShow="seqShow"
      :url="url"
      :method="method"
      :seachPlaceholder="placeholder"
      :pageSize="pageSize"
      :paramater="paramater"
      :visible="modalVisible"
      :keywordKey="keywordKey"
      :initKeyword="initKeyword"
      :isShowSelectPrice.sync="isSelectPrice"
      :setLocalStorageSelectPrice="setLocalStorageSelectPrice"
      :isForHighManage="isForHighManage"
      @on-cancel="onCancel"
      @on-ok="onOk"
    >
    </PgSelentMain>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { Input, Popover, Checkbox } from 'element-ui'
import { ref, shallowRef, watch, computed } from 'vue'
import PgSelentMain from './main.vue'
import { PgTable } from '../../table/index'
import { debounce } from 'lodash-es'
import { http, clone, setValueByPath, getValueByPath } from '../../../utils/index'
import {
  beforValueOldActionProps,
  useBeforValueOldActions,
  useComponentDefault,
} from '../../../hooks/index'
import { useDisplay } from '../hook/use-display'
import { usePrice } from '../hook/use-price'

const props = defineProps({
  idPrefix: String,
  columnTableCode: String,
  column: [Object, Array],
  seqShow: {
    type: Boolean,
    default: true,
  },
  width: {
    type: String,
    default: '740px',
  },
  //暂未实现多选的逻辑
  multiple: Boolean,
  url: String,
  method: {
    type: String,
    default: 'post',
  },
  paramater: Object,
  keywordKey: {
    type: String,
    default: 'parameters.keyword',
  },
  //选中项是否是对象
  valueIsObj: {
    type: Boolean,
    default: true,
  },
  // 单选结果返回数组
  valueIsArray: {
    type: Boolean,
    default: false,
  },
  //每页获取数据条数，为0或不存在时表示不使用分页查询
  pageSize: {
    type: Number,
    default: 20,
  },
  value: [String, Object, Array],
  //选中项的唯一值，当valueIsObj为true时直接返回查询接口返回的结构，否则返回查询接口返回的selectionKey对应的值
  selectionKey: {
    type: String,
    default: 'id',
  },
  //接口返回数据的唯一值，默认和selectionKey一样, 当多选或valueIsObj===faluse的时候必须和selectionKey一样
  requestDataKey: String,
  showName: {
    type: String,
    default: 'name',
  },
  showCode: {
    type: String,
    default: 'code',
  },
  disabled: Boolean,
  placeholder: {
    type: String,
    default: '编码/名称',
  },
  //待处理-我要采购订单 扫码页面注册证号弹出的问题
  zPopoverIndex: {
    type: Boolean,
    default: false,
  },
  //特殊处理参数 给高耗固网管理 系统编码和部件编码使用
  isForHighManage: {
    type: Boolean,
    default: false,
  },
  //特殊处理参数 给高耗固网管理 系统编码和部件编码使用
  customKey: {
    type: String,
    default: 'id',
  },
  validateEvent: {
    type: Boolean,
    default: true,
  },
  setLocalStorageSelectPrice: String,
  defaultValuePolicy: String,
  size: String,
  ...beforValueOldActionProps,
})

const emit = defineEmits(['input', 'on-change'])
const { beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})
const { changePrice } = usePrice(props)
const { visible: modalVisible, showRander, showEvent, onCancel, requestKey } = useDisplay(props)

const popoverRef = ref(null)

const initKeyword = ref('')
const showModal = () => {
  if (visible.value) {
    visible.value = false
  }
  showEvent()
}
const isSelectPrice = ref(changePrice())
//判断在获取焦点时是否需要打开下拉选项
const visible = ref(false)
const inputVal = ref('')
const setInputVal = (val) => {
  inputVal.value = val
  initKeyword.value = val
  searchMethod(inputVal.value)
}
const afterLeave = () => {
  initKeyword.value = ''
}
const inputBlur = () => {
  inputVal.value = valueStr.value
}
const inputFocus = () => {
  initKeyword.value = ''
}
const inputClick = () => {
  if (!visible.value) {
    searchMethod('')
  }
}
const inputRef = ref(null)
const inputClear = () => {
  inputVal.value = ''
  inputRef.value.focus()
  rowChange({ row: null })
}

const valueStr = computed(() => {
  if (props.valueIsObj) {
    let val = props.valueIsArray && Array.isArray(props.value) ? props.value[0] ?? '' : props.value
    const codeStr =
      props.showCode && getValueByPath(val, props.showCode)
        ? `(${getValueByPath(val, props.showCode)})`
        : ''
    const vaStr =
      props.showName && getValueByPath(val, props.showName)
        ? getValueByPath(val, props.showName)
        : ''
    return `${vaStr}${codeStr}`
  } else {
    return props.value ?? ''
  }
})

watch(
  valueStr,
  () => {
    inputVal.value = valueStr.value
  },
  { immediate: true }
)

watch(isSelectPrice, (newVal) => {
  localStorage.setItem(props.setLocalStorageSelectPrice, newVal)
})
watch(visible, (newVal) => {
  if (newVal) {
    isSelectPrice.value = changePrice()
  }
})
//获取表格数据
const page = shallowRef({
  pageNo: 1,
  pageSize: props.pageSize,
  totalCount: 0,
})
const pgTableRef = ref(null)
const loading = ref(false)
const getData = async (keyword) => {
  const param = clone(props.paramater) ?? {}
  if (page.value.pageSize) {
    param.pageNo = page.value.pageNo
    param.pageSize = page.value.pageSize
  }
  setValueByPath(param, props.keywordKey, keyword)
  loading.value = true
  const [res] = await http[props.method](props.url, param)
  loading.value = false
  if (res) {
    page.value.totalCount = res.totalCount ?? 0
    const resData =
      !!page.value.pageSize && page.value.pageNo > 1
        ? [...pgTableRef.value.getTableData().fullData, ...(res.data || [])]
        : res.data
    pgTableRef.value.loadData(resData)
    let values = props.multiple ? props.value : props.value && [props.value]
    if (!props.valueIsObj) {
      values =
        values &&
        values.map((im) => {
          const resItem = {}
          setValueByPath(resItem, props.selectionKey, im)
          return resItem
        })
    }
    if (values?.length > 0) {
      setTimeout(() => {
        const current = (res.data || []).find((im) =>
          values.some(
            (val) =>
              getValueByPath(im, requestKey.value) === getValueByPath(val, props.selectionKey)
          )
        )
        if (current) {
          pgTableRef.value.setCurrentRow(current)
          pgTableRef.value.scrollToRow(current)
          currentRow.value = current
        }
      })
    }
  }
}

const readenPopover = ref(false)
//设置下拉表格选中的逻辑
const currentRow = shallowRef(null)
const searchMethod = debounce((keyword) => {
  readenPopover.value = true
  visible.value = true
  page.value.pageNo = 1
  currentRow.value = null
  getData(keyword)
}, 200)
const onScroll = debounce((param) => {
  if (!props.pageSize) return
  const scrollDom = param.$event.target
  if (
    !loading.value &&
    scrollDom.scrollTop + scrollDom.clientHeight > scrollDom.scrollHeight - 20
  ) {
    const { fullData } = pgTableRef.value.getTableData()
    if (fullData.length === page.value.totalCount) {
      return
    }
    page.value.pageNo += 1
    getData(initKeyword.value)
  }
}, 100)

const rowChange = ({ row }) => {
  if (props.setLocalStorageSelectPrice) {
    setValueByPath(row, 'selectPrice', isSelectPrice.value)
  }
  if (props.isForHighManage) {
    let val = props.valueIsObj ? row : row && getValueByPath(row, props.customKey)
    emit('input', val)
    // let val2 = props.valueIsObj ? row : row && getValueByPath(row, requestKey.value)
    emit('on-change', val)
  } else {
    let val = props.valueIsObj ? row : row && getValueByPath(row, requestKey.value)
    if (props.valueIsObj && props.valueIsArray) {
      val = [val]
    }
    beforeEmit(val)
    emit('on-change', val)
  }
  initKeyword.value = ''
  visible.value = false
  inputRef.value.focus()
}
const onKeydown = (event) => {
  if (!visible.value || loading.value) return
  if (event.keyCode === 13) {
    //回车键
    if (currentRow.value) {
      rowChange({ row: currentRow.value })
      inputBlur()
    } else {
      const { fullData } = pgTableRef.value.getTableData()
      if (fullData.length === 1) {
        rowChange({ row: fullData[0] })
        inputBlur()
      } else if (fullData.length > 1) {
        showModal()
      }
    }
  } else if (event.keyCode === 38) {
    //按下向上键盘
    const { fullData } = pgTableRef.value.getTableData()
    if (!currentRow.value || fullData.length === 0) return
    const currentIndex = fullData.findIndex((im) => im._ID === currentRow.value._ID)
    const index = currentIndex === 0 ? fullData.length - 1 : currentIndex - 1
    currentRow.value = fullData[index]
    pgTableRef.value.setCurrentRow(currentRow.value)
    pgTableRef.value.scrollToRow(
      index + 1 === fullData.length || index === 0 ? fullData[index] : fullData[index - 1]
    )
  } else if (event.keyCode === 40) {
    //按下向下键盘
    const { fullData } = pgTableRef.value.getTableData()
    if (fullData.length === 0) return
    if (currentRow.value) {
      const currentIndex = fullData.findIndex((im) => im._ID === currentRow.value._ID)
      const index = currentIndex === fullData.length - 1 ? 0 : currentIndex + 1
      currentRow.value = fullData[index]
      pgTableRef.value.setCurrentRow(currentRow.value)
      pgTableRef.value.scrollToRow(
        index + 1 === fullData.length ? fullData[index] : fullData[index + 1]
      )
    } else {
      currentRow.value = fullData[0]
      pgTableRef.value.setCurrentRow(currentRow.value)
    }
  }
}
//阻止事件冒泡
const onEnter = (event) => {
  event.stopPropagation()
}

const onOk = (row) => {
  if (props.isForHighManage) {
    rowChange({ row })
  } else {
    const resRow = props.valueIsObj ? row : {}
    if (!props.valueIsObj) {
      setValueByPath(resRow, requestKey.value, row)
    }
    rowChange({ row: resRow })
  }
}

useComponentDefault({
  value: props.value,
  disabled: props.disabled,
  getData: () =>
    http[props.method](
      props.url,
      Object.assign(
        { pageNo: props.pageSize > 0 ? 1 : undefined, pageSize: props.pageSize ?? undefined },
        props.paramater
      ),
      { errorTip: null }
    ),
  type: props.defaultValuePolicy,
  setVal: (val) =>
    beforeEmit(props.valueIsObj ? val : val && getValueByPath(val, requestKey.value)),
})

defineExpose({
  onCancel,
  setValue: (row) => rowChange({ row }),
})
</script>
<style lang="scss">
@import '../slyle/dialog-select-table.scss';
</style>
